import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useI18n } from '../i18n'
import { Logo } from './ui/Logo'
import { OrderList } from './pricing/OrderList'

export default function OrdersPage() {
  const { t } = useI18n()

  return (
    <div className="min-h-screen bg-[#fafafa]">
      <header className="h-14 bg-white/70 backdrop-blur-2xl border-b border-black/[0.04] flex items-center px-4 sticky top-0 z-30">
        <Link to="/" className="flex items-center gap-2 text-lg font-semibold mr-2 shrink-0">
          <Logo size={24} />
          <span className="text-[#1a1a1a]">PrimeBook</span>
          <span className="text-orange-500">AI</span>
        </Link>
        <Link to="/workspace" className="px-3 py-1.5 text-[13px] rounded-lg text-gray-400 hover:text-[#1a1a1a] hover:bg-black/[0.04] transition-all">
          <ArrowLeft className="h-3.5 w-3.5 inline mr-1.5" />
          {t('返回工作台', 'Back')}
        </Link>
        <div className="ml-auto" />
      </header>

      <main className="max-w-2xl mx-auto px-6 py-8">
        <h1 className="text-xl font-semibold text-[#1a1a1a] mb-1">{t('订单记录', 'My Orders')}</h1>
        <p className="text-sm text-gray-400 mb-6">{t('查看你的支付记录和订单状态', 'View your payment history and order status')}</p>

        <div className="bg-white/70 backdrop-blur-xl rounded-2xl border border-white/80 p-6 shadow-[0_4px_24px_rgba(0,0,0,0.04)]">
          <OrderList />
        </div>
      </main>
    </div>
  )
}
